/*
 * Copyright (c) 2021
 *    Reliant Business Valuation, LLC - https://valzy.com
 *    Author: Kirill Vizniuk - kirill@reliantvalue.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Component, OnInit, OnDestroy } from '@angular/core';
import {CommonService, SocketService} from 'src/app/services';

@Component({
  selector: 'app-main-content',
  templateUrl: './main-content.component.html',
  styleUrls: ['./main-content.component.scss']
})
export class MainContentComponent implements OnInit, OnDestroy {

  constructor(
    private socketService: SocketService,
    public common: CommonService
  ) { }

  ngOnInit(): void {
    if (!localStorage.getItem('VALZY_RPT_INTRO_SKIP')) {
      localStorage.setItem('VALZY_RPT_INTRO_SKIP', 'false');
    }
    // Set Socket Token Config
    this.socketService.setAuthToken();
    this.socketService.connect();
  }

  ngOnDestroy(): void {
    this.socketService.disconnect();
  }
}
